<template>
  <div>
    <v-overlay :value="loading">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>

    <v-form v-model="valid">
      <v-container>
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="firstname"
              :rules="nameRules"
              label="First Name"
              required
              dark 
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="lastname"
              :rules="nameRules"
              label="Last Name"
              required
              dark 
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="12"
          >
            <v-text-field
              v-model="email"
              :rules="emailRules"
              label="Email Address"
              required
              dark 
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="12"
          >
            <v-text-field
              v-model="phone"
              label="Phone"
              dark 
            ></v-text-field>
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-col cols="12">
            <v-select
              v-model="selectedOption"
              :items="selectOptions"
              :rules="selectRules"
              dark
              label="Would you like someone to contact you?"
              required
              @change="$v.select.$touch()"
              @blur="$v.select.$touch()"
            ></v-select>
          </v-col>
        </v-row> -->
        <v-row>
          <v-col
            cols="12"
            md="12"
          >
            <span style="color: white;" class="vuetify-label">We would like to help you in your decision for Christ. How can we help ?</span>
            <v-list dark style="background:transparent;">
              <v-list-item 
                v-for="item in selectOptions"
                :key="item.id"
              >
                <v-checkbox 
                  v-model="selectOptionsModel"              
                  :label="item.name"  
                  :value="item" 
                  :value-comparator="comparator"
                  dark
                >
                </v-checkbox>
              </v-list-item>
            </v-list>

          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="text-right">
            <v-btn
              id="intouch-send"
              :disabled="!valid"
              large
              rounded
              class="px-10 font-weight-regular"
              color="secondary"
              @click="sendEmail"
            >
              <div style="color:white">SEND</div>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>

<script>

import axios from 'axios'
import Vue from 'vue'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css'
Vue.use(VueToast)

const instance = axios.create({
  baseURL: process.env.VUE_APP_EMAIL_API_URL,
  timeout: 50000,
  headers: {
    Accept: '*',
    'Content-Type': 'application/x-www-form-urlencoded',
    'Ocp-Apim-Subscription-Key': process.env.VUE_APP_EMAIL_API_KEY
  }
})

export default {
  name: 'DecisionForChristForm',
  data: () => ({
    valid: false,
    selectOptionsModel: [],
    selectOptions: [
      {
        id: 1,
        name: 'Start a Bible study / Answer a Bible question'
      },
      {
        id: 2,
        name: 'I want to recommit my life to Christ'
      },
      {
        id: 3,
        name: 'I want to be baptized'
      },
      {
        id: 4,
        name: 'Talk to someone'
      },
      {
        id: 5,
        name: 'Pray for me in making a decision for Christ'
      }
    ],
    firstname: '',
    lastname: '',
    nameRules: [
      (v) => !!v || 'Name is required'
    ],
    email: '',
    emailRules: [
      (v) => !!v || 'E-mail is required',
      (v) => /.+@.+/.test(v) || 'E-mail must be valid'
    ],
    phone: '',
    phoneRules: [
      (v) => !!v || 'Phone is required'
    ],
    subject: 'Decision For Christ',
    subjectRules: [
      (v) => !!v || 'Subject is required'
    ],
    message: '',
    messageRules: [
      (v) => !!v || 'Message is required'
    ],    
    selectedOption: '',
    selectRules: [
      (v) => !!v || 'Select an option'
    ],
    loading: false
  }),
  methods: {
    comparator(a, b) {
      return a.id === b.id
    },    
    async sendEmail() {

      this.loading = true

      const formData = new FormData()

      formData.append('senderName', `${this.firstname} ${this.lastname}`)
      formData.append('senderEmail', 'info@torontocentralsda.com')
      formData.append('recipients', 'tcpastoralstaff@torontocentralsda.com;seniorpastor@torontocentralsda.com')
      formData.append('subject', this.subject)

      let emailBody = `Name: ${this.firstname} ${this.lastname}\r\n`

      emailBody += `Email: ${this.email}\r\n`
      emailBody += `Subject: ${this.subject}\r\n`
      emailBody += `Phone: ${this.phone}\r\n`
      emailBody += `How can we help: ${this.selectedOption}\r\n`
      this.selectOptionsModel.forEach((element) => {
        emailBody += element.name + '\r\n'
      })
      // emailBody += `Message: ${this.message}\r\n`

      formData.append('emailBody', emailBody)

      axios ({
        method: 'post',
        data: formData,
        url: process.env.VUE_APP_EMAIL_API_URL,
        headers: {
          Accept: '*',
          'Content-Type': 'application/x-www-form-urlencoded',
          'Ocp-Apim-Subscription-Key': process.env.VUE_APP_EMAIL_API_KEY
        }
      })
        .then((response) => {
          this.loading = false
          this.resetForm()
          this.successToast()
        })
        .catch((error) => {
          console.log(error)
          this.failedToast()
        })
        .finally(() => this.loading = false)
    },
    resetForm() {
      this.fullname = ''
      this.email = ''
      this.message = ''
      this.selectedOption = ''
      this.selectOptionsModel = []
    },
    successToast() {
      Vue.$toast.open({
        message: 'Message successfully sent',
        type: 'success',
        position: 'top-right',
        duration: 7000
      })
    },
    failedToast() {
      Vue.$toast.open({
        message: 'Sorry, we were unable to send your message!',
        type: 'error',
        position: 'top-right',
        duration: 7000
      })
    }
  }
}
</script>

<style>
#intouch-send.v-btn--disabled {
    background-color: #ffffff20 !important;
}

.text-input-white .v-text-field__slot input {
   color: white !important;
}
</style>
